module.exports = __webpack_public_path__ + "img/medalla_oro_2021.1b4d5a5f.png";